export default "__VITE_ASSET__T3DFo1lh__"